import React from "react";
import { SectionTitle } from "./section-title";
import { useId } from "../../../hooks/use-id";

export const RequirementsSection = () => {
	const requirements = [
		"Participación en las sesiones de capacitación.",
		"Hacer parte del grupo de WhatsApp del piloto.",
		"Si hace parte del Grupo 1, participar en las capacitaciones especializadas.",
		"Contestar una (1) encuesta que se enviará en noviembre de 2026.",
	];

	const titleRegionId = useId('obligaciones');

	return (
		<section aria-labelledby={titleRegionId} className="p-3">
			<SectionTitle title="Obligaciones de los participantes" labelId= {titleRegionId}/>

			<div className="row p-3 justify-content-center align-items-center">
				<ul className="secondary-inverse--bg onsecondary-inverse--color p-5" style={{borderRadius:'1rem'}}>
					{requirements.map((requirement, index) => (
						<li key={index} className="" style={{fontSize:'1.2em'}}>
							<span className="font-weight-bold primary-inverse--color">{index+1}.</span>
							 {" "} {requirement}
						</li>
					))}
				</ul>
			</div>
		</section>
	);
};
